import { constraints, datatypes, inputTypes } from "data/globalData";

export const columnsObj = {
	size: {
		name: "Size",
		key: "size",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	qty_percent: {
		name: "Qty Percent",
		key: "qty_percent",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	qty: {
		name: "Qty",
		key: "qty",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	channel: {
		name: "Channel",
		key: "channel",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	warehouse: {
		name: "Warehouse",
		key: "warehouse",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummyTableData = [
	{
		id: 1,
		fabric_quality: "100% COTTON POPLIN",
		description: "BODY FABRIC",
		consumption: 2.2,
		order_qty: 155.0,
		recieved_qty: 341,
		supplier: "Benkatesh",
	},
	{
		id: 2,
		fabric_quality: "100% cotton  VOILE 92X80",
		description: "LINING",
		consumption: 1.53,
		order_qty: 92.0,
		recieved_qty: 140.76,
		supplier: "Drishya",
	},
];
export const defaultTotalRow = {
	id: "TOTAL",
	size: "TOTAL",
	order_qty: 0,
	recieved_qty: 0,
	difference_qty: 0,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row?.[columnsObj.size.key] === "TOTAL") return true;
	return false;
};
export const calculateTotalRow = (allRows) => {
	let qty_percent = 0;
	let qty = 0;
	allRows?.forEach((row) => {
		if (!isNaN(row?.[columnsObj.qty_percent.key])) qty_percent += +row?.[columnsObj.qty_percent.key];
		if (!isNaN(row?.[columnsObj.qty.key])) qty += +row?.[columnsObj.qty.key];
	});
	return {
		...defaultTotalRow,
		[columnsObj.qty_percent.key]: qty_percent,
		[columnsObj.qty.key]: qty,
	};
};
